export default __webpack_public_path__ + "static/media/track.2894466f.png";